import * as Debugger from 'debug';

export function getDebugger(name) {
  return new Debugger(`dav-frontend-consultorio-spa:${name}`);
}
